module.exports = __webpack_public_path__ + "img/team-3.d24661fc.png";